<div class="container-style">
  <div class="d-flex justify-content-between align-items-center ps-1 py-2 border-bottom">
    <div>
      <div class="d-flex flex-column">
        <span id="span-title" class="fw-bold"><i class="pi pi-list-check me-2"></i>Actividades <p-badge
            severity="secondary" [value]="maintenanceOrderActivities.length" /></span>
      </div>
    </div>

    <div class="gap-2 d-flex">
      <app-custom-button [title]="'Agregar Actividades'" [label]="'Agregar Actividades'" [icon]="'pi pi-plus'"
        [disabled]="maintenanceOrderActivities.length > 0 || disableCheckbox" [width]="'10.5rem'" [severity]="'success'"
        (onClick)="addActivities()"></app-custom-button>

      <app-custom-button [title]="'Eliminar Actividades'" [label]="'Eliminar Actividades'" [icon]="'pi pi-trash'"
        [disabled]="maintenanceOrderActivities.length == 0 || disableCheckbox || maintenanceOrderModel.maintenanceOrderOriginId!= null"
        [width]="'10.5rem'" [severity]="'danger'" (onClick)="deleteAllActivities()"></app-custom-button>
    </div>
  </div>
  <div id="table-activities" *ngIf="maintenanceOrderActivities.length > 0">
    <p-table [value]="maintenanceOrderActivities" [rows]="10" [scrollable]="true" stripedRows showGridlines
      styleClass="p-datatable-sm ">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 50px">Reg.</th>
          <th style="width: 80px">Código</th>
          <th style="width: 80px">Cód.Alterno</th>
          <th>Actividad</th>
          <th style="width: 85px" class="text-center">Ejecutada</th>
          <th style="width: 112px" class="text-center">Reprogramada</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-act let-colIndex=rowIndex>
        <tr>
          <td class="text-center">{{ colIndex + 1 }}</td>
          <td class="text-center">{{ act.maintenanceActivitiesCode }}</td>
          <td class="text-center">{{ act.maintenanceActivitiesAlterCode }}</td>
          <td>{{ act.maintenanceActivitiesDescription }}</td>
          <td class="text-center">
            <p-checkbox inputId="swExecuted{{act.maintenanceRoutineDetailId}}" binary="true" size="small"
              [(ngModel)]="act.swExecuted" [disabled]="disableCheckbox" autocomplete="off"
              (onChange)="changeCheckBox(act, 'swExecuted')" />
          </td>
          <td class="text-center">
            <p-checkbox inputId="swRescheduled{{act.maintenanceRoutineDetailId}}" binary="true" size="small"
              [(ngModel)]="act.swRescheduled" [disabled]="disableCheckbox" autocomplete="off"
              (onChange)="changeCheckBox(act, 'swRescheduled')" />
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>